import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { InegiService } from './inegi.service';
import { Customer } from 'src/app/components/customers/shared/customer';
import { OpenStreetMapService } from 'src/app/components/map/services/open-street-map.service';
import { Mark } from 'src/app/components/map/models/mark';
import { OneCoreMapHereComponent } from 'src/app/components/map/components/one-core-map-here/one-core-map-here.component';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { StreetMapLevelEnum } from 'src/app/enums/street-map-level-enum';
import { MessageService } from 'src/app/core/services/message.service';
import { Address } from 'src/app/Models/address';
import { FindMatchService } from '../../core/services/find-match.service';

@Component({
  selector: 'app-address-control',
  templateUrl: './address-control.component.html',
  styleUrls: ['./address-control.component.css']
})
export class AddressControlComponent implements OnInit {

  @Input() addressInput: Address;
  @Input() disable: boolean;

  options = {
    emitEvent: true,
    emitModelToViewChange: true,
    emitViewToModelChange: true,
  }

  street = new FormControl("", [Validators.required]);
  extNumber = new FormControl("", [Validators.required]);
  intNumber = new FormControl("");
  neighborhood = new FormControl("", [Validators.required]);
  city = new FormControl("", [Validators.required]);
  state = new FormControl("", [Validators.required]);
  zipCode = new FormControl("", [Validators.required]);

  lat: number = 0;
  long: number = 0;
  id: number = 0;

  neighborhoods: string[] = [];
  county: string;

  listCity: GeoWebCity[] = [];
  suggestedCity: any[] = [];
  listStreet: GeoWebStreet[] = [];
  suggestedStreet: any[] = [];
  listNeighboorhod: GeoWebNeighborhood[] = [];
  suggestedNeihgboorhod: any[] = [];

  timeOutSearch: any;

  stateKey: string;
  cityKey: string;

  start: Mark = {
    id: 1,
    lat: 0,
    lng: 0,
    color: 'blue'
  };

  displayedColumns: string[] = ['displayName', 'actions'];
  dataSource: any[] = [];
  dataSourceTemp: any[] = [];
  level: number = 1;
  searching: boolean = false;

  @ViewChild("oneCoreMap") oneCoreMap: OneCoreMapHereComponent;

  constructor(private service: InegiService, private openStreetMapService: OpenStreetMapService, 
    private messageService: MessageService, private findMatchService: FindMatchService) { }

  ngOnInit() {
    if(this.addressInput) {
      this.setAddressData(this.addressInput, false);
    } else {
      this.addressInput = new Address();
    }

    this.street.valueChanges.subscribe(() => {
      this.addressInput.street = this.street.value;
      this.searchCoincidenceStreet();
    });

    this.extNumber.valueChanges.subscribe(() => {
      this.addressInput.extNumber = this.extNumber.value;
    });

    this.intNumber.valueChanges.subscribe(() => {
      this.addressInput.intNumber = this.intNumber.value;
    });

    this.neighborhood.valueChanges.subscribe(() => {
      this.addressInput.neighborhood = this.neighborhood.value;
      this.searchStateNeighborhood();
    });

    this.city.valueChanges.subscribe(() => {
      this.addressInput.city = this.city.value;
      this.searchCoincidenceCity();
    });

    this.state.valueChanges.subscribe(() => {
      this.addressInput.state = this.state.value;
    });

    this.zipCode.valueChanges.subscribe(() => {
      this.addressInput.zipCode = this.zipCode.value;
    });
  }

  search() {
  }

  getAddressData() {
    if(!this.areControlsInvalid()) { this.onStopTimer(); }
    return {
      isInvalid: this.areControlsInvalid(),
      values: {
        id: this.id,
        street: this.street.value,
        extNumber: this.extNumber.value,
        intNumber: this.intNumber.value,
        neighborhood: this.neighborhood.value,
        city: this.city.value,
        state: this.state.value,
        zipCode: this.zipCode.value,
        lat: this.lat,
        long: this.long
      },
      
    }
  }

  changeMarker(mark: any){
    this.lat = mark.lat || mark.getPosition().lat || mark.b.lat;
    this.long = mark.lng || mark.getPosition().lng || mark.b.lng;
  }

  setAddressData(address: any, getCoord: boolean = false) {
    this.oneCoreMap.clearMarks();
    this.dataSource = [];

    this.id = address.id;
    this.street.setValue(address.street, this.options);
    this.extNumber.setValue(address.extNumber, this.options);
    this.intNumber.setValue(address.intNumber, this.options);
    this.city.setValue(address.city, this.options);
    this.state.setValue(address.state, this.options);
    this.zipCode.setValue(address.zipCode, this.options);
    this.neighborhood.setValue(address.neighborhood, this.options);
    this.long = address.longitude;
    this.lat = address.latitude;
  }

  setLatLong(lat: number, long: number) {
    this.long = long;
    this.lat = lat;

    this.setMap(this.lat, this.long);
  }

  private containsArray(array: string[], value: string) : string {
    return array.find(x => x.toLowerCase() === value.toLowerCase());
  }

  areControlsInvalid() {
    return this.street.invalid || this.extNumber.invalid || this.intNumber.invalid || this.neighborhood.invalid ||
      this.city.invalid || this.state.invalid || this.zipCode.invalid;
  }

  clearControls() {
    this.street.reset();
    this.extNumber.reset();
    this.intNumber.reset();
    this.neighborhoods = []
    this.neighborhood.reset();
    this.city.reset();
    this.state.reset();
    this.zipCode.reset();
  }

  getAddressCoord() {
    if (this.areControlsInvalid())
      return;
    
    this.dataSource = [];
    this.dataSourceTemp = [];
    this.searching = true;

    let address = this.transformAddressData();
    this.oneCoreMap.clearMarks();
    this.getAddressLevelSearch(this.level, address);
  }

  private getAddressLevelSearch(level: number, address: Address) : void {
    // this.getAddressOpen(level, address);
    this.getAddressNominatim(level, address);
  }

  private getAddressNominatim(level: number, address: Address) {
    this.openStreetMapService.getCoordinatesByAddress(address, this.getSearchLevel(level))
      .subscribe((response: any) => {
        if(response) {
          if(level <= 9) {
            this.addToDataSource(response);
            this.dataSource = this.dataSource.concat(this.dataSourceTemp);
            /*if(this.dataSource && this.dataSource.length) {
              this.setLatLong(this.dataSource[0].lat, this.dataSource[0].lon);
            }*/
            this.timeOutSearch = setTimeout(() => {
              this.getAddressLevelSearch(level + 1, address);
            }, 1000);
          } else if(level == 10 && this.dataSourceTemp && this.dataSourceTemp.length) {
            // this.dataSource = this.dataSourceTemp;
            this.searching = false;
          } else if(!this.dataSourceTemp || this.dataSourceTemp.length) {
            this.messageService.warning('DELIVERY_OPERATIVE.DETAIL.MESSAGES.TITLE_STREET', 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.STREET_NOT_FOUND', { street: address.street, number: address.extNumber, zip: address.zipCode });
          }
        }
      });
  }

  private getAddressOpen(level: number, address: Address) {
    this.openStreetMapService.getCoordinatesByAddressOpen(address, this.getSearchLevel(level))
      .subscribe((response: any) => {
        if(response.status === 'OK' && response.results) {
          if(level <= 9) {
            this.addToDataSource(response.results);
            this.timeOutSearch = setTimeout(() => {
              this.getAddressLevelSearch(level + 1, address);
            }, 1000);
          } else if(level == 10 && this.dataSourceTemp && this.dataSourceTemp.length) {
            this.dataSource = this.dataSourceTemp;
            this.setLatLong(response.results[0].geometry.location.lat, response.results[0].geometry.location.lng);
            this.searching = false;
          } else if(!this.dataSourceTemp || this.dataSourceTemp.length) {
            this.messageService.warning('DELIVERY_OPERATIVE.DETAIL.MESSAGES.TITLE_STREET', 'DELIVERY_OPERATIVE.DETAIL.MESSAGES.STREET_NOT_FOUND', { street: address.street, number: address.extNumber, zip: address.zipCode });
          }
        }
      });
  }

  private addToDataSource(address: any[]) {
    if(!this.dataSourceTemp || !this.dataSourceTemp.length) {
      this.dataSourceTemp = address;
    }else {
      let found = false;
      address.forEach(a => {
        found = false;
        this.dataSourceTemp.forEach(d => {
          if(d.lat == a.lat && d.lon == a.lon) {
          // if(d.geometry.location.lat == a.geometry.location.lat && d.geometry.location.lng == a.geometry.location.lng) {
            found = true;
          }
        });
        if(!found) {
          this.dataSourceTemp.push(a);
        }
      });
    }
  }

  private getSearchLevel(level: number) : string[] {
    return StreetMapLevelEnum['LEVEL_' + level];
  }

  private transformAddressData(): any {
    let address = this.getAddressData().values;
    let countryData = {
      id: 1,
      country: 'México',
    };

    return Object.assign({}, address, countryData);
  }

  private setMap(lat: number, lon: number): void {
    this.start.lat = lat;
    this.start.lng = lon;
    if(this.start.lat && this.start.lng) {
      this.oneCoreMap.clearMarks();
      this.oneCoreMap.setStartMarks(this.start);
      this.oneCoreMap.setMapCenter(this.start);

      this.addressInput.latitude = this.start.lat;
      this.addressInput.longitude = this.start.lng;
    }
  }

  searchCoincidence(): void {
    if(this.county) {
      this.searching = true;
      this.searchState();
    }
  }

  private searchState(): void {
    this.service.getCounty(this.county).subscribe((response: any) =>{
      let data = response.datos as GeoWebState[];
      if(data && data.length >= 0) {
        this.searchCounty(data[0].cve_agee);
      }
    });
  }

  private searchCounty(stateKey: string): void {
    this.service.getCounty(this.county).subscribe((response: any) =>{
      let data = response.datos as GeoWebCounty[];
      if(data && data.length >= 0) {
        this.searchCity(stateKey, data[0].cve_agem);
        // this.searchNeighborhood(stateKey, data[0].cve_agem);
      }
    });
  }

  private searchCity(stateKey: string, countyKey: string): void {
    this.service.getCity(stateKey, countyKey).subscribe((response: any) => {
      let data = response.datos as GeoWebCity[];
      if(data) {
        this.listCity = data;
        if(this.city.value) {
          this.searchCoincidenceCity();
        }
        this.searchStreet(stateKey, data[0].cve_agem);
      }
    });
  }

  private searchCoincidenceCity() {
    if(this.city.value && this.listCity && this.listCity.length) {
      let result = this.getMatch(this.city.value, this.listCity, 'nom_loc');
      this.suggestedCity = result.data;
    } else {
      this.suggestedCity = [];
    }
  }

  private searchNeighborhood(stateKey: string, countyKey: string): void {
    this.service.getNeighborhood(stateKey, countyKey).subscribe((response: any) => {
      let data = response.datos as GeoWebNeighborhood[];
      if(data) {
        let result = this.getMatch(this.neighborhood.value, data, 'nom_asen');
        this.suggestedNeihgboorhod = result.data;
        this.onSelectNeighboorhod(result.best.target);
      }
    });
  }

  private searchStateNeighborhood(): void {
    if(this.neighborhood.value && this.neighborhoods && this.neighborhoods.length) {
      let result = this.getMatch(this.neighborhood.value, this.neighborhoods);
      this.suggestedNeihgboorhod = result.data;
    }
  }

  private searchStreet(stateKey: string, countyKey: string): void {
    this.service.getStreet(stateKey, countyKey).subscribe((response: any) => {
      let data = response.datos as GeoWebStreet[];
      if(data) {
        this.listStreet = data;
        if(this.street.value) {
          this.searchCoincidenceStreet();
        }
        this.searching = false;
      }
    });
  }

  private searchCoincidenceStreet() {
    if(this.street.value && this.listStreet && this.listStreet.length) {
      let result = this.getMatch(this.street.value, this.listStreet, 'nom_via');
      this.suggestedStreet = result.data;
    } else {
      this.suggestedStreet = [];
    }
  }

  private getMatch(value: string, data: any[], key?: string): any {
    let result = this.findMatchService.findBestMatch(value, data, key);
    if(result) {
      let sort = result.ratings.sort(this.sortMatchResult);
      if(sort) {
        return { 
          best: result.bestMatch,
          data: sort.splice(0, 5) 
        };
      }
    }
    return {};
  }

  private sortMatchResult(a, b): number {
    return a.rating > b.rating ? -1 : 1;
  }

  private mapResult(item) : string {
    return item.target;
  }

  onSelectCity(value: string): void {
    this.city.setValue(value, this.options);
  }

  onSelectNeighboorhod(value: string): void {
    this.neighborhood.setValue(value, this.options);
  }

  onSelectStreet(value: string): void {
    this.street.setValue(value, this.options);
  }

  onStopTimer() {
    if(this.timeOutSearch) {
      clearTimeout(this.timeOutSearch);
      this.searching = false;
    }
  }

}

export interface InegiData {
  codigo_postal: string;
  municipio: string;
  estado: string;
  colonias: string[];
}

export interface GeoWebData {
  cve_agee: string; // Clave estado
  cve_agem: string; // Clave municipio
}

export interface GeoWebState extends GeoWebData {
  nom_agee: string;
}

export interface GeoWebCounty extends GeoWebData {
  nom_agem: string;
}

export interface GeoWebCity extends GeoWebData {
  nom_loc: string; // Nombre ciudad
}

export interface GeoWebNeighborhood extends GeoWebData {
  nom_asen: string; // Nombre ciudad
}

export interface GeoWebStreet extends GeoWebData {
  nom_via: string; // Nombre de la calle
}
